import { Box, styled } from '@mui/material';
import { SmartActionState } from '../../SmartActionDialog.types';
import { Icon } from '@sdb/planning-ui';

export const Container = styled(Box)({
  display: 'flex',
  gap: '16px'
});

export const IconContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px'
});

export const ContentContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'state'
})<{ state: SmartActionState }>(({ theme, state }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(4),
  width: '100%',
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,

  ...(() => {
    switch (state) {
      case SmartActionState.LOADING:
      case SmartActionState.SUCCESS:
        return {
          pointerEvents: 'none',
          '> *': {
            opacity: 0.3
          }
        };
      default:
        return {};
    }
  })()
}));

export const StatusIcon = styled(Icon, {
  shouldForwardProp: (prop) => prop !== 'state'
})<{ state: SmartActionState }>(({ theme, state }) => ({
  width: '24px',
  height: '24px',
  padding: theme.spacing(1),
  borderRadius: '50%',
  ...(() => {
    switch (state) {
      case SmartActionState.ERROR:
        return {
          backgroundColor: theme.palette.error.main,
          color: theme.palette.error.contrastText
        };
      case SmartActionState.SUCCESS:
        return {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.background.paper
        };
      default:
        return {
          backgroundColor: theme.vars.palette.surface.containerHigh,
          color: theme.palette.primary.main,
          opacity: 0.5
        };
    }
  })()
}));
